<template>
  <div class="manner_box">
    <h3 class="activeR">我的态度</h3>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="收费" name="correct"></el-tab-pane>
      </el-tabs>
      <el-card>
        <h6>
          <span>[德甲] 门兴 0-1 勒沃库森</span>
        </h6>
        <!-- <b class="activeH">单选:主胜</b> -->
        <div class="content">门兴不败</div>
        <p class="pp">
          <span>2021-03-05 09:39</span>
          <span class="pp_span">
            <span><i class="el-icon-s-promotion"></i>转发</span>
            <span><i class="el-icon-chat-dot-square"></i>评论</span>
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <i class="el-icon-more"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>仅自己看(是)</el-dropdown-item>
                  <el-dropdown-item>关闭评论</el-dropdown-item>
                  <el-dropdown-item>投诉</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </span>
        </p>
      </el-card>
    </div>
    <!-- 没有权限 -->
    <div class="jurisdiction">
      <img src="../../../assets/Notifications_Isometric.png" />
      <h4 class="activeH">您还没有权限发布文章</h4>
      <h4>
        如需开通权限，请你将您的履历和范文发送至<span>
          yemachenaiwenhua@163.com</span
        >
      </h4>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
export default {
  setup() {
    let activeName = ref('all')
    let handleClick = () => {}
    return {
      activeName,
      handleClick
    }
  }
}
</script>
<style scoped lang="less">
.manner_box {
  h3 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  b {
    color: #000;
    font-size: 14px !important;
  }
  .el-card {
    h6 {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 10px 0;
      .xz {
        font-size: 14px;
        padding: 2px 6px;
        background: red;
        border-radius: 4px;
        color: #fff;
      }
    }
    .activeH {
      // margin: 10px;
    }
    .content {
      background: #eee;
      padding: 10px;
      font-size: 14px;
      border-radius: 10px;
      margin: 10px 0;
    }
    .pp {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #8c8c8c;
      font-weight: 600;
      .pp_span {
        span {
          margin: 0 10px;
        }
      }
    }
  }
}

.jurisdiction {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h4 {
    font-weight: 600;
    line-height: 30px;
    span {
      color: #2f7edc;
    }
  }
  img {
    width: 400px;
  }
}
</style>
